import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface Props {
	onClick: (dayIndex: number) => void;
	selectedDays: number[];
}

const AvailabilityHeader: React.FC<Props> = ({ onClick, selectedDays }) => {
	const { t } = useTranslation();

	const weekdays = t("WEEKDAYS_CHARS").split(" ");

	return (
		<Styles>
			{weekdays.map((d, i) => (
				<div
					key={d + i}
					onClick={() => onClick(i)}
					className={selectedDays.includes(i) ? "selected" : ""}
				>
					{d}
				</div>
			))}
		</Styles>
	);
};

const Styles = styled.div`
	display: flex;
	justify-content: space-around;
	cursor: pointer;

	div {
		min-width: 17px;
		text-align: center;
		border-bottom: 2px solid transparent;

		@media (min-width: 1280px) {
			min-width: 19px;
		}

		&:hover:not(.selected) {
			border-color: ${(props) => props.theme.colors.COLOR_BORDER_LIGHT};
			opacity: 0.5;
		}
	}

	/* Weekend markers: darker than pure red, which is only ~4:1 on white and
	   vibrates at label sizes */
	div:nth-last-child(-n + 2) {
		color: #b91c1c;
	}

	.selected {
		border-color: ${(props) => props.theme.colors.COLOR_BLACK};
	}
`;

export default AvailabilityHeader;
